const BACKEND_SERVER_NAME = "rissearch.at";
const BACKEND_SERVER_PORT = "443";
const BACKEND_USE_HTTPS = "1";

const protocol = BACKEND_USE_HTTPS === "1" ? "https" : "http";
const serverName = BACKEND_SERVER_NAME;
const serverPort = BACKEND_SERVER_PORT;

const backendServerUrl = `${protocol}://${serverName}:${serverPort}`;

export {
    backendServerUrl
};
